<template>
  <lf-content-loader :is-loading="runScorecardIds.includes(model.id)">
    <table-text-truncated
      :model-value="model.name"
      :model="model"
      show-badge
      :show-run-button="!pageIsView && isWorkflowLive"
      :score-card-group="isScorecardGroup"
    >
      <scorecard-edit-manual :model="model" />
    </table-text-truncated>
  </lf-content-loader>
</template>

<script setup lang="ts">
import { useScorecardsBase } from "@/hooks/scorecards";

import ScorecardEditManual from "@/components/scorecards/ScorecardEditManual.vue";
import TableTextTruncated from "@/components/scorecards/TableTextTruncated.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

defineProps<{
  model: IScorecard;
  pageIsView?: boolean;
  isWorkflowLive?: boolean;
  isScorecardGroup?: boolean;
}>();
</script>
